import React from "react";

export const JuridicoProcessContext = React.createContext();